import { fetchRemoteConfig, getRemoteValue } from '../firebase/remoteConfig';

const VARIANT = (process.env.REACT_APP_VARIANT || 'PODESUBIR').toLowerCase();

const ENV_FALLBACKS = {
  urclyrd: {
    links: {
      sms_terms_url: process.env.REACT_APP_LINKS_TERMS || 'https://urclyrd.com/terms',
      sms_privacy_url: process.env.REACT_APP_LINKS_PRIVACY || 'https://urclyrd.com/privacy',
      sms_help_email: process.env.REACT_APP_LINKS_CONTACT || 'contact@urclyrd.com',
    },
  },
  podesubir: {
    links: {
      sms_terms_url:
        process.env.REACT_APP_LINKS_TERMS || 'http://www.podesubir.com/termos-e-condicoes',
      sms_privacy_url:
        process.env.REACT_APP_LINKS_PRIVACY || 'http://www.podesubir.com/politica-de-privacidade',
      sms_help_email: process.env.REACT_APP_LINKS_CONTACT || 'contact@podesubir.com',
    },
  },
};

let appConfig = null;

const buildConfig = () => {
  const fallback = ENV_FALLBACKS[VARIANT];

  let remote = {};
  try {
    const raw = getRemoteValue(VARIANT).asString();
    remote = JSON.parse(raw);
  } catch (_) {}

  return {
    sms_disclosure_text: remote.sms_disclosure_text || '',
    links: {
      terms: remote.links.sms_terms_url || fallback.links.sms_terms_url,
      privacy: remote.links.sms_privacy_url || fallback.links.sms_privacy_url,
      contact: remote.links.sms_help_email || fallback.links.sms_help_email,
    },
  };
};

export const initAppConfig = async () => {
  await fetchRemoteConfig();
  appConfig = buildConfig();
  return appConfig;
};

export const getAppConfig = () => appConfig;
